import { render, staticRenderFns } from "./WaitAction.vue?vue&type=template&id=9745c996"
import script from "./WaitAction.vue?vue&type=script&lang=js"
export * from "./WaitAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports